(() => {
  const selector = '#MainContent img, .product__media img, .product-media-modal__content > img, .card__media img, .quick-add-modal__content-info-media img, .camma-home__product-image img, .camma-home__bed-image img, .camma-home__hero-image, .camma-shop .cs-photo img, .camma-compare-card img, .camma-bed-visualizer img';
  function protect(img) {
    img.setAttribute('data-camma-protected', '');
    img.draggable = false;
    const link = img.closest('a');
    if (link) {
      link.draggable = false;
      link.setAttribute('data-camma-image-link', '');
    }
  }
  function scan(root) {
    if (!(root instanceof Element) && root !== document) return;
    if (root instanceof HTMLImageElement && root.matches(selector)) protect(root);
    root.querySelectorAll(selector).forEach(protect);
  }
  function init() {
    scan(document);
    new MutationObserver(records => {
      records.forEach(record => record.addedNodes.forEach(node => {
        if (node instanceof Element) scan(node);
      }));
    }).observe(document.body, { childList:true, subtree:true });
    document.addEventListener('shopify:section:load', event => scan(event.target));
    const isProtected = target => target instanceof Element && (target.matches(selector) || target.closest('[data-camma-image-link]') || target.closest('.product__modal-opener--image,.card-wrapper,.quick-add-modal__content-info-media')?.querySelector('img[data-camma-protected]'));
    document.addEventListener('contextmenu', event => { if (isProtected(event.target)) event.preventDefault(); }, true);
    window.addEventListener('dragstart', event => { if (isProtected(event.target)) { event.preventDefault(); event.stopPropagation(); } }, true);
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init, { once:true });
  else init();
})();
